import React from 'react'
import { coreMustacheRenderers } from './coreMustacheRenderers'
import { escapeAndRenderTemplate, MustacheRendererProps } from './shared'

/**
 * This component exists so we can render mustache templates that are delivered from the API.
 * This should not be used for any other use case.
 */
export function MustacheRenderer({
  tagName: Tag,
  template,
  views,
  truncate
}: MustacheRendererProps) {
  const rendered = escapeAndRenderTemplate({
    template,
    views,
    coreMustacheRenderers
  })
  return (
    <Tag
      dangerouslySetInnerHTML={{
        __html:
          typeof truncate === 'number'
            ? rendered.substring(0, truncate)
            : rendered
      }}
    />
  )
}
